import React from 'react'
import {Link} from 'react-router-dom'

function AdminNav(props) {
    return (
        <ul className="nav justify-content-center p-3">
            <li className="nav-item">
                <Link className={`nav-link ${props.page === "admin" && "text-info"}`} to="/admin">Admin</Link>
            </li>
            <li className="nav-item">
                <Link className={`nav-link ${props.page === "hostcup" && "text-info"}`} to="/hostcup/admin">Høstcup</Link>
            </li>
        </ul>
    )
}
export default AdminNav